import React, { MouseEvent } from 'react';
import { FullLogoIcon } from '@components/Icons';

type Props = {
  whiteOnMobile?: boolean
  height?: number
  width?: number
  href?: string
}

export const HIQLogo: React.FunctionComponent<Props> = ({
  whiteOnMobile,
  width,
  height,
  href,
  ...props
}) => (
  <div {...props}>
    <FullLogoIcon
      whiteOnMobile={whiteOnMobile}
      height={height}
      width={width}
    />
  </div>
)
